import { initDB } from '../db';
import type { WizardRepository } from './WizardRepository';
import type { WizardState } from '@/types/wizard';

export class IndexedDBWizardRepository implements WizardRepository {
  async getWizardState(): Promise<WizardState | undefined> {
    const db = await initDB();
    const all = await db.getAll('wizard');
    // Return the most recent active wizard, or the latest one
    const active = all.find((w) => w.active);
    return active ?? all[0];
  }

  async saveWizardState(state: WizardState): Promise<void> {
    const db = await initDB();
    await db.put('wizard', state);
  }

  async clearWizardState(): Promise<void> {
    const db = await initDB();
    await db.clear('wizard');
  }
}
